import urlUtil from 'common/util/url/urlUtil';

import { AppSpecifiedRoutingService } from 'common/services/commonRoutingService';
import store from '../store';
import { RootState } from '../store/rootReducer';
import { ContextUrlSearchStringObject } from '../store/context/types';
import { ContextState } from '../store/context/reducer';

const routingService: AppSpecifiedRoutingService = {
    getNewContextFromLocation(location: { search: string }): ContextUrlSearchStringObject {
        return urlUtil.parseLocationSearchString(location.search) as ContextUrlSearchStringObject;
    },

    getUrlRelevantPropsFromContext() {
        const state: RootState = store.getState() as RootState;
        const {
            workspaceId, contextId, qtiContextItemId,
        }: ContextState = state.context;

        return {
            workspaceId, contextId, qtiContextItemId,
        };
    },
};

export default routingService;
